import { ControlFacet } from '../models/controls/ControlFacet';

export type ItemCacheSuspenseMode = 'debounce';

export const itemCacheSuspenseControl: ControlFacet<{}, {
  mode: ItemCacheSuspenseMode;
}> = new ControlFacet('itemCacheSuspense');
